module.exports = __webpack_public_path__ + "img/smoke4.28998de8.png";